// Demo.tsx
import React, { useState } from 'react';
import usePollingWithIdleCheck from '../usePollingWithIdleCheck';
import { ArrowDownOutlined } from '@ant-design/icons';

const Demo: React.FC = () => {
    // 轮询次数计数器
    const [pollCount, setPollCount] = useState(0);

    // 模拟的轮询函数，每次执行时增加轮询次数
    const mockCheckLock = () => {
        setPollCount(prevCount => prevCount + 1); // 累加轮询次数
    };

    // 使用自定义轮询 Hook
    const { isPolling } = usePollingWithIdleCheck({
        checkLockFn: mockCheckLock,
        idleTimeout: 5000,  // 空闲 5 秒后停止轮询
        interval: 3000,      // 每 3 秒执行一次轮询操作
        leading: true,
    });

    // 用于显示轮询状态和轮询次数
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>轮询测试页面</h1>
            <p style={{ color: isPolling ? 'red' : '' }}>当前轮询状态: {isPolling ? "轮询中..." : "已暂停"}</p>
            <p>轮询次数(每 3 秒执行一次轮询操作): {pollCount}</p>
            <p>（在页面空闲 5 秒后轮询会暂停，任何操作会重新启动轮询）</p>

            {/* ReactDOMServer.renderToStaticMarkup(<ArrowDownOutlined color={color} /> */}
            {/* <ArrowDownOutlined  style={{ color: 'red' }} /> */}
        </div>
    );
};

export default Demo;